function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "Image load failed."
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "",
        " uploaded successfully."
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "",
        " upload failed."
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "",
        " exceeds maximum size limit (",
        ")"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "",
        " is not an image"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "Error cropping image."
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "Click or drag file to this area to upload"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "Supported file types: *.jpeg, *.jpg, *.png, *.bmp, *.webp and *.gif"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "Supported file types: *.jpeg, *.jpg, *.png, *.bmp and *.webp"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "The maximum file size per image is ",
        "."
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
import React, { useState, useEffect, useReducer, useCallback } from "react";
import { Upload as AntUpload, message } from "antd";
import { t } from "ttag";
import { InboxOutlined } from "@ant-design/icons";
import { Status } from "../../services/image-service";
import { formatBytes } from "../../services/file-service";
import Preview from "./Preview";
import ImageCrop from "../ImageCrop";
var Actions;
(function(Actions) {
    Actions[Actions["ImagePopulate"] = 0] = "ImagePopulate";
    Actions[Actions["ImageReset"] = 1] = "ImageReset";
    Actions[Actions["HideCropModal"] = 2] = "HideCropModal";
    Actions[Actions["ShowCropModal"] = 3] = "ShowCropModal";
})(Actions || (Actions = {}));
export var TYPE_PERSON_PROFILE_PIC = "profile";
var defaultState = {
    cropSource: null,
    imageCropVisible: false,
    currentImageId: null,
    currentImageUrl: null,
    naturalWidth: null,
    naturalHeight: null
};
var reducer = function(state, action) {
    switch(action.type){
        case Actions.ImagePopulate:
            {
                var _action_payload, _action_payload1;
                return _objectSpreadProps(_objectSpread({}, state), {
                    imageCropVisible: false,
                    currentImageId: action.payload.imageId,
                    currentImageUrl: action.payload.url,
                    naturalHeight: (_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.naturalHeight,
                    naturalWidth: (_action_payload1 = action.payload) === null || _action_payload1 === void 0 ? void 0 : _action_payload1.naturalWidth
                });
            }
        case Actions.ImageReset:
            {
                return _objectSpread({}, state, defaultState);
            }
        case Actions.ShowCropModal:
            {
                return _objectSpreadProps(_objectSpread({}, state), {
                    imageCropVisible: true,
                    cropSource: action.payload.src,
                    currentImageId: action.payload.imageId
                });
            }
        case Actions.HideCropModal:
            {
                if (typeof action.payload !== "undefined") {
                    return _objectSpreadProps(_objectSpread({}, state), {
                        imageCropVisible: false,
                        cropSource: null,
                        currentImageId: action.payload.imageId,
                        currentImageUrl: action.payload.url
                    });
                }
                return _objectSpreadProps(_objectSpread({}, state), {
                    cropSource: null,
                    imageCropVisible: false
                });
            }
        default:
            return _objectSpread({}, defaultState);
    }
};
var Dragger = AntUpload.Dragger;
var ALLOWED_MIME_TYPES = [
    "image/png",
    "image/jpeg",
    "image/jpg",
    "image/bmp",
    "image/webp"
];
var MAXIMUM_ALLOWED_FILE_SIZE = 1024 * 1024 * 24;
var STATUS_DONE = "done";
var STATUS_ERROR = "error";
var STATUS_UPLOADING = "uploading";
var ImageUpload = function(param) {
    var resourceId = param.resourceId, resourceType = param.resourceType, _param_cropSettings = param.cropSettings, cropSettings = _param_cropSettings === void 0 ? {} : _param_cropSettings, _param_enableCrop = param.enableCrop, enableCrop = _param_enableCrop === void 0 ? false : _param_enableCrop, _param_height = param.height, height = _param_height === void 0 ? 200 : _param_height, _param_onComplete = param.onComplete, onComplete = _param_onComplete === void 0 ? function() {} : _param_onComplete, policyName = param.policyName, tmp = param.value, _ref = tmp === void 0 ? {
        id: null
    } : tmp, imageId = _ref.id, _param_width = param.width, width = _param_width === void 0 ? 200 : _param_width, _param_token = param.token, token = _param_token === void 0 ? "" : _param_token, _param_allowGif = param.allowGif, allowGif = _param_allowGif === void 0 ? false : _param_allowGif, _param_information = param.information, information = _param_information === void 0 ? "" : _param_information, _param_originalDimensions = param.originalDimensions, originalDimensions = _param_originalDimensions === void 0 ? false : _param_originalDimensions, _param_circularCrop = param.circularCrop, circularCrop = _param_circularCrop === void 0 ? false : _param_circularCrop, getFn = param.getFn, cropFn = param.cropFn, createFn = param.createFn, uploadFn = param.uploadFn, notifyFn = param.notifyFn;
    var _useReducer = _slicedToArray(useReducer(reducer, defaultState), 2), state = _useReducer[0], dispatch = _useReducer[1];
    var _useState = _slicedToArray(useState(null), 2), status = _useState[0], setStatus = _useState[1];
    // not all browsers we support have event.target but all of them have event.composedPath function
    var extractTarget = useCallback(function(e) {
        if (typeof e.target !== "undefined") {
            return e.target;
        }
        if (typeof e.composedPath === "function") {
            var _e_composedPath = _slicedToArray(e.composedPath(), 1), target = _e_composedPath[0];
            return target;
        }
        return {};
    }, []);
    var effect = useCallback(/*#__PURE__*/ _asyncToGenerator(function() {
        var imageParams, image, onLoad, img, e;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    imageParams = originalDimensions ? {} : {
                        scale_width: width,
                        scale_height: height,
                        user_crop: true,
                        fit_in: true,
                        fill_color: "#FFFFFF"
                    };
                    return [
                        4,
                        getFn(resourceId, imageId, imageParams, token, resourceType)
                    ];
                case 1:
                    image = _state.sent();
                    onLoad = function(event) {
                        var target = extractTarget(event);
                        var _target_naturalHeight = target.naturalHeight, naturalHeight = _target_naturalHeight === void 0 ? height : _target_naturalHeight, _target_naturalWidth = target.naturalWidth, naturalWidth = _target_naturalWidth === void 0 ? width : _target_naturalWidth;
                        dispatch({
                            type: Actions.ImagePopulate,
                            payload: {
                                imageId: imageId,
                                url: image.imageUrl,
                                naturalHeight: naturalHeight,
                                naturalWidth: naturalWidth
                            }
                        });
                    };
                    if (image === null || image === void 0 ? void 0 : image.imageUrl) {
                        img = new Image();
                        img.src = image.imageUrl;
                        img.onload = onLoad;
                        return [
                            2
                        ];
                    }
                    // dispatch with empty values if imageUrl is null
                    dispatch({
                        type: Actions.ImagePopulate,
                        payload: {
                            imageId: imageId,
                            url: image.imageUrl
                        }
                    });
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    message.error(t(_templateObject()));
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    // TODO Remove the eslint-disable and fix the problem
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [
        imageId,
        resourceId,
        resourceType,
        token,
        width,
        height,
        originalDimensions
    ]);
    useEffect(function() {
        // When the crop window closes this effect should be called
        if (resourceId && imageId && !state.imageCropVisible) {
            effect();
        }
    }, [
        resourceId,
        resourceType,
        imageId,
        state.imageCropVisible,
        effect
    ]);
    var onChange = function(info) {
        var file = info.file;
        if (file.status === STATUS_DONE) {
            message.success(t(_templateObject1(), info.file.name));
        } else if (file.status === STATUS_ERROR) {
            message.error(t(_templateObject2(), info.file.name));
        }
        setStatus(file.status);
    };
    var onRequest = function() {
        var _ref = _asyncToGenerator(function(request) {
            var file, onProgress, _ref, imageUploadId, upload, _, err, _ref1, imageUrl, id, onLoad, img;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        file = request.file;
                        onProgress = function(progress) {
                            return request.onProgress({
                                percent: progress.loaded / progress.total * 100
                            });
                        };
                        return [
                            4,
                            createFn(resourceId, file.name, file.type, file.size, policyName, token, resourceType)
                        ];
                    case 1:
                        _ref = _state.sent(), imageUploadId = _ref.id, upload = _ref.upload;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        _ = request.onSuccess;
                        return [
                            4,
                            uploadFn(upload.url, file, onProgress)
                        ];
                    case 3:
                        _.apply(request, [
                            _state.sent()
                        ]);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        err = _state.sent();
                        request.onError(err);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            4,
                            notifyFn(resourceId, imageUploadId, Status.Finalized, token, resourceType)
                        ];
                    case 6:
                        _ref1 = _state.sent(), imageUrl = _ref1.imageUrl, id = _ref1.id;
                        onLoad = function(event) {
                            var target = extractTarget(event);
                            var _target_naturalHeight = target.naturalHeight, naturalHeight = _target_naturalHeight === void 0 ? height : _target_naturalHeight, _target_naturalWidth = target.naturalWidth, naturalWidth = _target_naturalWidth === void 0 ? width : _target_naturalWidth;
                            dispatch({
                                type: Actions.ImagePopulate,
                                payload: {
                                    imageId: id,
                                    url: imageUrl,
                                    naturalHeight: naturalHeight,
                                    naturalWidth: naturalWidth
                                }
                            });
                            onComplete({
                                id: id,
                                imageUrl: imageUrl
                            });
                        };
                        img = new Image();
                        img.src = imageUrl;
                        img.onload = onLoad;
                        return [
                            2
                        ];
                }
            });
        });
        return function onRequest(request) {
            return _ref.apply(this, arguments);
        };
    }();
    var onReset = function() {
        setStatus(null);
        dispatch({
            type: Actions.ImageReset
        });
        onComplete({
            id: null
        });
    };
    var maxFileSize = formatBytes(MAXIMUM_ALLOWED_FILE_SIZE);
    var beforeUpload = function(file, fileList) {
        // validation for file size
        if (file.size > MAXIMUM_ALLOWED_FILE_SIZE) {
            message.error(t(_templateObject3(), file.name, maxFileSize));
            // eslint-disable-next-line no-param-reassign
            file.status = "error";
            return false;
        }
        // validation for unsupported file types
        if (!(ALLOWED_MIME_TYPES.includes(file.type) || allowGif && file.type === "image/gif")) {
            message.error(t(_templateObject4(), file.name));
            fileList.splice(fileList.indexOf(file), 1);
            return false;
        }
        return true;
    };
    var onCrop = function() {
        var _ref = _asyncToGenerator(function(cropPayload) {
            var croppedImage, e;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            cropFn(resourceId, state.currentImageId, cropPayload, token, resourceType)
                        ];
                    case 1:
                        croppedImage = _state.sent();
                        dispatch({
                            type: Actions.HideCropModal,
                            payload: {
                                imageId: croppedImage.id,
                                url: croppedImage.imageUrl
                            }
                        });
                        onComplete({
                            id: state.currentImageId,
                            imageUrl: croppedImage.imageUrl
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        message.error(t(_templateObject5()));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function onCrop(cropPayload) {
            return _ref.apply(this, arguments);
        };
    }();
    var onCropClick = function() {
        var _ref = _asyncToGenerator(function() {
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getFn(resourceId, imageId, {
                                crop: "no_crop"
                            }, token, resourceType).then(function(image) {
                                return dispatch({
                                    type: Actions.ShowCropModal,
                                    payload: {
                                        src: image.imageUrl,
                                        imageId: image.id
                                    }
                                });
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function onCropClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, status !== STATUS_DONE && state.currentImageUrl == null ? /*#__PURE__*/ React.createElement(Dragger, {
        showUploadList: true,
        customRequest: onRequest,
        beforeUpload: beforeUpload,
        accept: allowGif ? "image/jpeg,.jpeg,.jpg,image/png,.png,image/bmp,.bmp,image/webp,.webp,.gif" : "image/jpeg,.jpeg,.jpg,image/png,.png,image/bmp,.bmp,image/webp,.webp",
        onChange: onChange,
        disabled: status === STATUS_DONE || status === STATUS_UPLOADING
    }, /*#__PURE__*/ React.createElement("p", {
        className: "ant-upload-drag-icon"
    }, /*#__PURE__*/ React.createElement(InboxOutlined, null)), /*#__PURE__*/ React.createElement("p", {
        className: "ant-upload-text"
    }, t(_templateObject6())), /*#__PURE__*/ React.createElement("p", {
        className: "ant-upload-hint"
    }, allowGif ? t(_templateObject7()) : t(_templateObject8())), /*#__PURE__*/ React.createElement("p", {
        className: "ant-upload-hint"
    }, t(_templateObject9(), maxFileSize), " ", information)) : /*#__PURE__*/ React.createElement(Preview, {
        image: state.currentImageUrl,
        enableCrop: enableCrop,
        height: originalDimensions ? state.naturalHeight : height,
        onDelete: onReset,
        onCropClick: onCropClick,
        width: originalDimensions ? state.naturalWidth : width
    }), state.imageCropVisible && /*#__PURE__*/ React.createElement(ImageCrop, {
        visible: true,
        src: state.cropSource,
        settings: cropSettings,
        onCropSaveClick: onCrop,
        onModalClose: function() {
            return dispatch({
                type: Actions.HideCropModal
            });
        },
        circularCrop: circularCrop
    }));
};
export default ImageUpload;
